import { Tabs, TabsItem } from "@/components";
import {
  ENROLL_PLATFORM_TAB_ITEMS,
  type EnrollPlatform,
} from "../../_constants/enroll-platforms.const";
import styles from "./EnrollPlatformToolbar.module.scss";

type EnrollPlatformToolbarProps = {
  platform: EnrollPlatform;
  onPlatformChange: (value: EnrollPlatform) => void;
};

export const EnrollPlatformToolbar = ({
  platform,
  onPlatformChange,
}: EnrollPlatformToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <Tabs
        value={platform}
        onChange={(value) => onPlatformChange(value as EnrollPlatform)}
        variant="secondary"
        size="medium"
      >
        {ENROLL_PLATFORM_TAB_ITEMS.map((item) => (
          <TabsItem key={item.value} value={item.value}>
            {item.label}
          </TabsItem>
        ))}
      </Tabs>
    </div>
  );
};
